import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { rand } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import { sortable, pageable } from './utils.js'

export type SpeciesData = SchemaAttributes<'Species'>

export const model = Model as ModelDefinition<SpeciesData>

const AVAILABLE_SPECIES = [
  { name: 'Cat', icon: 'generic-feline' },
  { name: 'Dog', icon: 'generic-canine' },
  { name: 'Bird', icon: 'generic-birds' },
  { name: 'Rabbit', icon: 'generic-leporidae' },
  { name: 'Horse', icon: 'generic-equidae' },
  { name: 'Ferret', icon: 'generic-pet-paw' },
  { name: 'Guinea Pig', icon: 'generic-pet-paw' },
  { name: 'Hamster', icon: 'generic-pet-paw' },
  { name: 'Fish', icon: 'generic-pet-paw' },
  { name: 'Reptile', icon: 'generic-pet-paw' },
] as const

export const factory = Factory.extend<SpeciesData>({
  name() {
    return rand(AVAILABLE_SPECIES).name
  },
  species_icon() {
    const speciesData = AVAILABLE_SPECIES.find((s) => s.name === this.name)
    return speciesData?.icon || 'generic-pet-paw'
  },
})

export function routes(server: MockServer) {
  server.get('/species', function (this: MirageServer, schema, request) {
    const allSpecies = schema.all('species')
    const sorted = sortable(allSpecies, request)
    const paginated = pageable(sorted, request)
    return this.serialize(paginated.data)
  })
}

export function seeds(server: MockServer) {
  // Create all available species
  AVAILABLE_SPECIES.forEach(({ name, icon }) => {
    server.create('species', {
      name,
      species_icon: icon,
    })
  })
}
